/**
 * Applies a cart discount code via Cart API before standard cart checkout submit.
 * Buttons opt in with data-apply-otp-discount="CODE" (set from Liquid when OTP display savings apply).
 *
 * @see https://shopify.dev/docs/api/ajax/reference/cart#post--locale-cart-update-js ("Update discounts in the cart")
 */
(function () {
  if (window.__cartCheckoutOtpDiscountBound) return;
  window.__cartCheckoutOtpDiscountBound = true;

  document.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest('button[name="checkout"][data-apply-otp-discount]');
      if (!btn || btn.disabled || !btn.form) return;

      const code = (btn.getAttribute('data-apply-otp-discount') || '').trim();
      const updateUrl = window.routes && window.routes.cart_update_url;
      if (!code || !updateUrl) return;

      e.preventDefault();

      btn.setAttribute('aria-busy', 'true');
      const wasDisabled = btn.disabled;
      btn.disabled = true;

      try {
        await fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ discount: code }),
        });
      } catch {
        /* proceed to checkout; customer can apply code manually */
      }

      btn.removeAttribute('aria-busy');
      btn.disabled = wasDisabled;

      const form = btn.form;
      let proxy = form.querySelector('input[name="checkout"][data-otp-checkout-proxy="1"]');
      if (!proxy) {
        proxy = document.createElement('input');
        proxy.type = 'hidden';
        proxy.name = 'checkout';
        proxy.setAttribute('data-otp-checkout-proxy', '1');
        form.appendChild(proxy);
      }
      form.submit();
    },
    true
  );
})();
